import ScrollToTop from "../hooks/scroll-to-top";
import React,{useEffect} from "react";
import { animationCreate } from "../utils/utils";


const Wrapper = function(props) {
  React.useEffect(function() {
    setTimeout(function() {
      animationCreate();
    }, 500);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.children, /*#__PURE__*/React.createElement(ScrollToTop, null));
};

export default Wrapper;